module.exports = __webpack_public_path__ + "static/media/NothingHereIllustration.a1323635.svg";